export default {
	data() {
    return {}
  },
  props: ['entreprise']
}